import React, { useState, useEffect, useRef, useCallback } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { Form } from "react-bootstrap";

const SingleInputDateRangePicker = ({
  onDateChange,
  initialStartDate,
  initialEndDate,
}) => {
  const [startDate, setStartDate] = useState(
    initialStartDate ? new Date(initialStartDate) : null
  );
  const [endDate, setEndDate] = useState(
    initialEndDate ? new Date(initialEndDate) : null
  );
  const [isOpen, setIsOpen] = useState(false);
  const datePickerRef = useRef(null);

  // Handler to clear the date(s)
  const handleClear = (onChange) => {
    setStartDate(null);
    setEndDate(null);
    onDateChange("", "");
  };

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = useCallback(
    (dates) => {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
      // const formattedStartDate = start ? start.toISOString().split("T")[0] : "";
      // const formattedEndDate = end ? end.toISOString().split("T")[0] : "";
      const formattedStartDate = formatDate(start);
      const formattedEndDate = formatDate(end);
      onDateChange(formattedStartDate, formattedEndDate);
    },
    [onDateChange]
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const isSelectedDate = !!(startDate || endDate);

  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="d-flex align-items-center gap-2 date-range-input">
      <img src="/images/png/calendar.png" width={20} height={20} alt="" />
      <Form.Control
        type="text"
        // className="form-control"
        onClick={(e) => {
          onClick(e);
          setIsOpen(!isOpen);
        }}
        value={value || ""}
        readOnly
        ref={ref}
        placeholder="select date range"
      />
    </div>
  ));

  return (
    <>
      <div
        className="d-flex align-items-center date-range-picker position-relative"
        ref={datePickerRef}
      >
        <DatePicker
          selectsRange
          startDate={startDate}
          endDate={endDate}
          onChange={handleDateChange}
          isClearable
          customInput={<CustomInput />}
          withPortal={false}
          popperPlacement="bottom-start"
          open={isOpen}
          onCalendarOpen={() => setIsOpen(true)}
          onCalendarClose={() => setIsOpen(false)}
          monthsShown={2}
          dateFormat="MMM d, yyyy"
        />

        {isSelectedDate && (
          <img
            src="/images/png/close-1.png"
            className={`me-2 pointer-cursor position-absolute end-0 me-1`}
            width={20}
            height={20}
            alt="Clear date"
            onClick={() => handleClear()}
          />
        )}
        {/* {startDate && endDate && (
                <div className="mt-2 small text-muted">
                    Selected: {startDate.toLocaleDateString()} - {endDate.toLocaleDateString()}
                </div>
            )} */}
      </div>
    </>
  );
};

export default SingleInputDateRangePicker;
